import { Button, Popup, ScrollView, ValidationGroup } from "devextreme-react";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { hcostInboundAtom, hcostInboundBrokerageValueAtom, hcostInboundDesignsValueAtom } from "@/store/hcost-atom";
import React, { useEffect, useState } from "react";
import { CommonConst } from "@constants/common-const";
import { saveHCostInbound } from "@service/hcost/hcost-result-service";
import { loadPanelAtom } from "@/store/global";
import { cloneDeep } from "lodash-es";
import CounselCommon from "@feature/counsel/update/counsel-common";
import { useRouter } from "next/router";
import { HCOST_INBOUND_DATA } from "@constants/hcost/hcost-data";
import useCounselHook from "@feature/counsel/useCounselHook";
import { saveFile } from "@service/s3-service";
import CounselCustomerInfo from "@feature/counsel/update/counsel-customer-info";
import CounselSystemInfo from "@feature/counsel/update/counsel-system-info";
import CounselAddInfo from "@feature/counsel/update/counsel-add-info";
import CounselConstructionInfo from "@feature/counsel/update/counsel-construction-info";
import CounselDesignInfo from "@feature/counsel/update/counsel-design-info";
import CounselSummary from "@feature/counsel/update/counsel-summary";
import { ToolbarItem } from "devextreme/ui/popup";

type Props = {
  popupDetailVisible(value: boolean): void;
  refreshDataSource?(): void;
  accessType: string;
  isBrokerage?: boolean;
  counselId: number;
};

const CounselPopupDetailV3 = ({ popupDetailVisible, refreshDataSource, accessType, isBrokerage, counselId }: Props) => {
  const [hCostResult, setHCostResult] = useAtom(hcostInboundAtom);
  const [validationGroup, setValidationGroup] = useState(null);
  const [hCostDesignValue] = useAtom(hcostInboundDesignsValueAtom);
  const hCostBrokerageValue = useAtomValue(hcostInboundBrokerageValueAtom);
  const setLoadPanel = useSetAtom(loadPanelAtom);
  const [selectedIndex] = useState(0);
  const router = useRouter();
  const { getHCostCounsel } = useCounselHook();

  useEffect(() => {
    void getHCostCounsel(counselId, accessType, selectedIndex);
  }, [counselId, getHCostCounsel, accessType, selectedIndex]);

  useEffect(() => {
    return () => {
      setHCostResult(cloneDeep(HCOST_INBOUND_DATA));
    };
  }, [setHCostResult]);

  // 유효성 검사 관련
  /** 밸리데이션 그룹 유효성 검증결과 */
  const isValidateGroup = (validationGroup: any) => {
    const res = validationGroup.instance.validate();

    if (!res.isValid) {
      return res.brokenRules[0].validator.focus();
    }
    return validationGroup ? validationGroup.instance.validate().isValid : true;
  };

  const saveCounselFile = async () => {
    for (const value of hCostResult.counselAttachedFiles) {
      if (value.filePresignedUrl) {
        await saveFile({ "content-type": value.fileExtension }, value.filePresignedUrl, value.file);
      }
    }
  };

  const updateHCostResult = () => {
    const isValidGroup: boolean = isValidateGroup(validationGroup);
    if (isValidGroup) {
      setLoadPanel(true);
      saveHCostInbound(
        CommonConst.MODIFY_TYPE_INBOUND_UPDATE,
        { ...hCostResult, designs: hCostDesignValue, counselBrokerages: hCostBrokerageValue },
        accessType,
      )
        .then(async (id: number): Promise<void> => {
          void getHCostCounsel(id, accessType, selectedIndex);
          refreshDataSource();
        })
        .finally(() => setLoadPanel(false));
    }
  };

  const toolbarItems: Array<ToolbarItem> = [
    {
      location: "after",
      widget: "dxButton",
      options: {
        icon: "close",
        type: "back",
        text: "닫기",
        onClick: () => {
          popupDetailVisible(false);
        },
      },
    },
  ];

  const handleSubmit = async () => {
    // if (hCostResult.designs.length) {
    //   setAlertModalVisible(true);
    // } else {
    //   updateHCostResult();
    // }
    await saveCounselFile();
    await updateHCostResult();
  };

  return (
    <>
      <Popup
        animation={undefined}
        hideOnOutsideClick={false}
        dragEnabled={false}
        showCloseButton={false}
        showTitle={true}
        toolbarItems={toolbarItems}
        visible={true}
        height="100vh"
        maxHeight="100vh"
        maxWidth="2000"
        minWidth="400"
        title="시공상담 수정"
        width="96%"
        onHiding={() => popupDetailVisible(false)}
      >
        <div className="flex h-full">
          <ScrollView showScrollbar="always" className="basis-1/2">
            <ValidationGroup ref={ref => setValidationGroup(ref)}>
              <div className="card-body pr-5">
                {/*요약 정보*/}
                <CounselSummary selectedIndex={selectedIndex} />
                {/*고객 정보*/}
                <CounselCustomerInfo accessType={accessType} />

                {/*설계 정보*/}
                <CounselDesignInfo accessType={accessType} />

                {/*시공 정보*/}
                <CounselConstructionInfo />

                {/*추가 정보*/}
                <CounselAddInfo />

                {/*시스템 정보*/}
                <CounselSystemInfo accessType={accessType} />
              </div>
            </ValidationGroup>
          </ScrollView>

          {/*견적 상담*/}
          <CounselCommon accessType={accessType} refreshDataSource={refreshDataSource} isBrokerage={isBrokerage} />
        </div>

        <div className="card-footer content-footer fixed-bottom bg-white mt-3 text-center">
          <div className="flex justify-center py-5">
            <Button className="mx-[5px] h-[42px] min-w-[100px]" type="default" onClick={handleSubmit}>
              저장
            </Button>
            <Button className="mx-[5px] h-[42px] min-w-[100px]" type="back" onClick={() => popupDetailVisible(false)}>
              닫기
            </Button>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default CounselPopupDetailV3;
